import { jsPDF } from 'jspdf'

import moment from 'moment'

import pages from './pages'
import templates from '../templates'

import constants from 'constants/index'
import helpers from 'helpers'
import * as service from 'service'
import * as Sentry from '@sentry/react'

import '../fonts/Raleway-Bold-normal'
import '../fonts/Raleway-Thin-normal'
import '../fonts/Roboto-Regular-normal'
import '../fonts/Roboto-Bold-normal'

moment.locale('pt-br')
var dateNow = moment().format('MMM YYYY')

dateNow = dateNow.charAt(0).toUpperCase() + dateNow.slice(1)

const exportPdf = async ({
  customLogo,
  customPalette,
  customStyles,
  fragilityStats,
  gapStats,
  generalStats,
  processStats,
  refresh,
  setExportingPdf,
  setLoading,
  shouldCreateVersion,
  snackbar,
  supplierStats,
  userCompany,
}) => {
  const pdf = new jsPDF({
    orientation: 'portrait',
    unit: 'px',
    userUnit: 300,
  })

  try {
    setLoading(true)

    templates.firstCover({
      pdf,
      companyName: userCompany?.company?.name,
      document: userCompany?.company?.document,
      date: dateNow,
      customStyles,
      customLogo,
      reportName: 'Relatório Gerencial da Adequação à LGPD \nVisão Geral',
    })

    if (!customPalette?.status) {
      pages.disclaimer(pdf, dateNow, customStyles)
    }

    const skippedPages = customPalette?.status ? 1 : 3

    pages.summary(pdf)

    pages.introduction({
      pdf,
      date: `Introdução | ${dateNow}`,
      customStyles,
      skippedPages,
    })

    await pages.generalInformation({
      pdf,
      date: `Visão Geral | ${dateNow}`,
      generalStats,
      gapStats,
      processStats,
      fragilityStats,
      customStyles,
      skippedPages,
    })

    await pages.processes({
      pdf,
      date: `Processos | ${dateNow}`,
      processStats,
      customStyles,
      skippedPages,
    })

    await pages.diagnostics({
      date: `Diagnóstico | ${dateNow}`,
      pdf,
      gapStats,
      customStyles,
      fragilityStats,
      skippedPages,
    })

    await pages.incidents({
      pdf,
      date: `Incidentes | ${dateNow}`,
      generalStats,
      customStyles,
      skippedPages,
    })

    await pages.suppliers({
      pdf,
      date: `Fornecedores | ${dateNow}`,
      supplierStats,
      customStyles,
      skippedPages,
    })

    templates.lastCover({ pdf, customStyles, customLogo })

    const reportName = `Relatório_gerencial_${userCompany?.company?.name
      ?.split(' ')
      ?.join('_')
      ?.toLowerCase()}_${dateNow}.pdf`

    pdf.save(reportName)

    if (shouldCreateVersion) {
      const file = new File([pdf.output('blob')], reportName)

      await service.dponet.reportVersions.create({
        file,
        name: 'Relatório Gerencial',
        kind: constants.reportVersions.KIND.MANAGEMENT,
      })

      refresh()
    }

    snackbar.open({
      variant: 'success',
      message: 'Relatório gerado com sucesso, aguarde o download começar',
    })
  } catch (error) {
    console.error(error)

    snackbar.open({
      variant: 'error',
      message:
        helpers.formatters.errorMessage(error) ||
        'Ocorreu um erro ao gerar o relatório',
    })
    Sentry.captureException(error)
  } finally {
    setExportingPdf(false)
    setLoading(false)
  }
}

export default exportPdf
